/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ids: NonNullable<unknown> }} Admin_Funnel_Footnote_ExcludedInputs */

const en_admin_funnel_footnote_excluded = /** @type {(inputs: Admin_Funnel_Footnote_ExcludedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Excluded: test user ${i?.ids} and every visitor id that user has used.`)
};

/**
* | output |
* | --- |
* | "Excluded: test user {ids} and every visitor id that user has used." |
*
* @param {Admin_Funnel_Footnote_ExcludedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_excluded = /** @type {((inputs: Admin_Funnel_Footnote_ExcludedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_ExcludedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_excluded(inputs)
});
export { admin_funnel_footnote_excluded as "admin.funnel.footnote.excluded" }